import styled from 'styled-components/macro';

import { border, borderRadius, boxShadow } from 'variables/general';
import { fontWeightBold } from 'variables/font';
import { white, black, grey5 } from 'variables/colors';
import { index10 } from 'variables/z-index';
import { FlexCenterVertical } from 'styles/flexbox';

export const StickyHeader = styled.header `
  z-index: ${index10};
  background-color: ${white};
`;

export const Header = styled.div `
  display: flex;
  align-items: center;
  justify-content:space-between;
  padding-bottom: 0em;
  border-bottom: ${border};
`;

export const HeaderRight = styled(FlexCenterVertical)
``;

export const MoreMenu = styled.div `
  position: absolute;
  top: 4em;
  right: 0;
  padding: 1em 0;
  font-size: 14px;
  background-color: ${white};
  border-radius: ${borderRadius};
  box-shadow: ${boxShadow};
`;

export const MoreMenuOption = styled(FlexCenterVertical)
`
  padding: 0.5em 1em;
  color: ${black};
  font-weight: ${fontWeightBold};

  white-space: nowrap;

  &:hover {
    background-color: ${grey5};
  }

  .MuiSvgIcon-root {
    margin-right: 0.25em;
  }
`;

export const Link = styled.a `
  font-size: 1em;
`;